/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const FocusedNavigationWrapper = styled.div({
  paddingTop: token('space.600'),
  paddingLeft: token('space.200'),
  display: 'flex',
  height: '100vh',
});
